import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercent, faGlobe, faUsers } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const StatsSection = () => {
  return (
    <div className="stats-section">
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-number">
            <FontAwesomeIcon icon={faPercent} />
          </div>
          <div className="stat-label">Zero comissão na venda</div>
          <div className="stat-description">
            Você só paga para colocar o anúncio online, uma única vez, após validação do virtual.
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-number">
            <FontAwesomeIcon icon={faGlobe} />
          </div>
          <div className="stat-label">Visibilidade nacional e internacional</div>
          <div className="stat-description">
            O seu anúncio é traduzido automaticamente para mais de 20 idiomas e divulgado internacionalmente, permitindo alcançar potenciais compradores em mais de 50 países.
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-number">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div className="stat-label">+ 1 milhão de visitas por mês</div>
          <div className="stat-description">
            Receba os dados de potenciais compradores diretamente por email.
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection; 